import React from "react";
import { useTranslate } from "react-admin";

import { PortSelectInput } from "./PortSelectInput";

export const choices = [
	{ id: 1, name: "1" },
	{ id: 2, name: "2" },
	{ id: 3, name: "3" },
	{ id: 4, name: "4" },
	{ id: 5, name: "5" },
	{ id: 6, name: "6" },
	{ id: 7, name: "7" },
	{ id: 8, name: "8" },
	{ id: 9, name: "9" },
	{ id: 10, name: "10" },
	{ id: 11, name: "11" },
	{ id: 12, name: "12" },
	{ id: 13, name: "13" },
	{ id: 14, name: "14" },
	{ id: 15, name: "15" },
	{ id: 16, name: "16" },
];

export const PortInput = ({ filter, ...props }) => {
	const translate = useTranslate();
	const translationPath = props.label ? props.label : "resources.orders.fields." + props.source;
	const { terminal_id: terminalIds, ...portsFilter } = filter ?? {};

	return (
		<PortSelectInput
			{...props}
			filter={portsFilter}
			terminalId={terminalIds?.[0]}
			label={translate(translationPath)}
		/>
	);
};
